import { render, staticRenderFns } from "./InstanceTopBar.vue?vue&type=template&id=9936ff0c&scoped=true"
import script from "./InstanceTopBar.vue?vue&type=script&lang=js"
export * from "./InstanceTopBar.vue?vue&type=script&lang=js"
import style0 from "./InstanceTopBar.vue?vue&type=style&index=0&id=9936ff0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9936ff0c",
  null
  
)

export default component.exports